import { Inject } from '@odinjs/odin';

import { APPLICATION_ROUTES, Endpoint, ToastServiceStipulator } from '@philips-emr/hpms-stipulator-commons';
import { ToastNotificationAPI } from '@philips-emr/tws-components';
import Controller, { OnBeforeSubmit, OnCancel, OnClose, OnMount } from '@philips-emr/tws-core/lib/client';
import { SubmitEvent } from '@philips-emr/tws-core/lib/component/types';
import { HistoryService, HttpService, MessageService } from '@philips-emr/tws-core/lib/services';

import BaseController from '../BaseController';

@Controller({ fragment: 'finalizar-repasse', component: 'panel-finalizar-repasse' })
class FinalizarRepasseController extends BaseController {

  @Inject('toast-notification')
  private toastForm: ToastNotificationAPI;

  @OnMount({ target: 'panel-finalizar-repasse' })
  onMount(): void {
    const { nrSeqBeneficiario } = HistoryService.getCurrentRouteParams();
    this.context.set({ nrSeqBeneficiario });
  }

  @OnBeforeSubmit({ target: 'form-finalizar-repasse' })
  onBeforeSubmit(event: SubmitEvent): void {
    const { nrSeqGrupoContratoWeb, nrSeqContrato } = HistoryService.getCurrentRouteParams();
    const body = event.record;

    HttpService.post(Endpoint.POST.FINALIZAR_REPASSE, { nrSeqContrato }, { body })
      .then(() => {
        ToastServiceStipulator.success(MessageService.translate('stipulator.aviso-solicitacao-realizada'));
        HistoryService.push(APPLICATION_ROUTES.ALTERACAO_BENEFICIARIO, { nrSeqGrupoContratoWeb, nrSeqContrato });
      })
      .catch(() => {
        this.toastForm.setVisible(true);
      });
  }

  @OnCancel({ target: 'form-finalizar-repasse' })
  onCancelForm(): void {
    const { nrSeqGrupoContratoWeb, nrSeqContrato } = HistoryService.getCurrentRouteParams();
    HistoryService.push(APPLICATION_ROUTES.ALTERACAO_BENEFICIARIO, { nrSeqGrupoContratoWeb, nrSeqContrato });
  }

  @OnClose({ target: 'toast-notification' })
  onCloseToast(): void {
    this.toastForm.setVisible(false);
  }

}
export default FinalizarRepasseController;
